import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { MatDialog } from '@angular/material';

import { MessageFormComponent } from '../message-form/message-form.component';

@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.scss'],
  providers: [AngularFireDatabase, AngularFireAuth],
})
export class UserViewComponent implements OnInit {
  user : any = {};
  currentUser : any = {};
  id : any;
  currentTab : Number = 1;
  discussions: Observable<any[]>;
  replies: Observable<any[]>;
  nextPoints : any = 1;

  constructor(private db: AngularFireDatabase,
     private route : ActivatedRoute,
     public dialog : MatDialog,
     public afAuth : AngularFireAuth,
     private router : Router) {
  }

  ngOnInit() {
    this.afAuth.auth.onAuthStateChanged(user => {
      this.currentUser = user;
    });

    this.route.params.subscribe(params => {
      this.db.object(`usernames/${params['id']}`)
        .snapshotChanges()
        .subscribe(snapshot => {
          if ( snapshot.key ) {
            this.id = snapshot.payload.val();
          } else {
            this.id = params['id'];
          }

          this.db.object('profiles/'+ this.id)
          .snapshotChanges()
          .subscribe(user => {
            this.user = user.payload.val();
            this.loadDiscussions();
            this.loadResponses();
          });
        });
    });
  }

  setTab(number) {
    this.currentTab = number;
  }

  loadDiscussions() {
    let forumsRef = this.db.list('discussions', ref => ref.orderByChild('userId').equalTo(this.user.userId))

    this.discussions = forumsRef.snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.key, ...c.payload.val() }));
    });
  }

  loadResponses() {
    let repliesRef = this.db.list('replies', ref => ref.orderByChild('userId').equalTo(this.user.userId))

    this.replies = repliesRef.snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.key, ...c.payload.val() }));
    });
  }

  newMessage() {
    let messageDialog = this.dialog.open(MessageFormComponent,  {
      data: {
        user: this.user
      }
    });
  }

  getProgress() {
    if (this.user) {
      this.nextPoints = ((this.user.rank || 0 ) + 1) * 1000;
      const progress = ((this.user.points || 0) / this.nextPoints);

      return progress * 250;
    }
    return 0;
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/users/user-view/user-view.component.ts